import React from 'react'

const Spacer = () => {
    return (
        <span className="hidden leading-none md:block fixed-btn">&nbsp;</span>
    )
}

export default Spacer
